import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import HeaderBar from "../../components/HeaderBar";
import VehicleLayoutWrapper from "../../components/VehicleLayoutWrapper";
import getCurrentSkin from "../../utils/getCurrentSkin";
import { ThemeContext } from "../../context/ThemeContext";

import {
  FaPlus,
  FaSearch,
  FaList,
  FaTrash,
  FaEye,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const API_BASE = "https://nissi-india.com/api/ownDetailsListing";
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
const DEFAULT_PAGE_SIZE = 10;

const OwnDetailsListing = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;
  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;
  const tableHeaderClass = buttonClass;

  const navigate = useNavigate();

  const finYearId = localStorage.getItem("finYearId") || "";
  const finYear = localStorage.getItem("finYear") || "";
  const branchId =
    localStorage.getItem("branchId") || localStorage.getItem("branchid") || "";
  const branchType =
    localStorage.getItem("branchType") ||
    localStorage.getItem("branchtype") ||
    "BR";
  const userId =
    localStorage.getItem("userId") || localStorage.getItem("loginuserid") || "";
  const branchActive =
    sessionStorage.getItem("BranchActive") ||
    sessionStorage.getItem("branchActive") ||
    "1";

  const commonHeaders = useMemo(
    () => ({
      "x-finyearid": finYearId,
      "x-finyear": finYear,
      "x-branchid": branchId,
      "x-branch": branchType,
      "x-userid": userId,
    }),
    [finYearId, finYear, branchId, branchType, userId]
  );

  const [selectedView, setSelectedView] = useState("ownVehicle");

  const [branches, setBranches] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [stores, setStores] = useState([]);
  const [spareBranches, setSpareBranches] = useState([]);
  const [spareMainTypes, setSpareMainTypes] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const [selectedBranchId, setSelectedBranchId] = useState(branchId || "");
  const [storeId, setStoreId] = useState("Select");
  const [vehicleTypeIndex, setVehicleTypeIndex] = useState("Select");

  const [vehicleCode, setVehicleCode] = useState("");
  const [vehicleName, setVehicleName] = useState("");
  const [vehicleRegNo, setVehicleRegNo] = useState("");
  const [vehicleMake, setVehicleMake] = useState("");
  const [vehicleModel, setVehicleModel] = useState("");

  const [spareBranchId, setSpareBranchId] = useState(branchId || "Select");
  const [spareMainTypeId, setSpareMainTypeId] = useState("Select");
  const [spareVehicleCode, setSpareVehicleCode] = useState("");
  const [spareItem, setSpareItem] = useState("");
  const [spareModel, setSpareModel] = useState("");
  const [spareMake, setSpareMake] = useState("");
  const [spareSlNo, setSpareSlNo] = useState("");

  const [showFilters, setShowFilters] = useState(true);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [viewRow, setViewRow] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(DEFAULT_PAGE_SIZE);
  const [total, setTotal] = useState(0);
  const [listMode, setListMode] = useState("search");

  const totalPages = useMemo(() => {
    const t = Number(total);
    const l = Number(limit);
    if (!Number.isFinite(t) || !Number.isFinite(l) || l <= 0) return 1;
    return Math.max(1, Math.ceil(t / l));
  }, [total, limit]);

  const pageStart = total === 0 ? 0 : (page - 1) * limit + 1;
  const pageEnd = Math.min(page * limit, total || rows.length);

  const inputClass = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all ${
    isDark
      ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
      : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
  }`;

  const labelClass = `block mb-2 text-sm font-medium ${
    isDark ? "text-gray-300" : "text-gray-700"
  }`;

  const pageTitle =
    selectedView === "ownVehicle"
      ? "Own Vehicle Details Listing"
      : selectedView === "sparesAndCatalogue"
      ? "Spares And Catalogue Listing"
      : "Spares Scrap Listing";

  const ownVehicleModalFields = [
    { key: "vehicleCode", label: "Vehicle Code" },
    { key: "vehicleName", label: "Vehicle Name" },
    { key: "vehicleRegNo", label: "Vehicle Reg No" },
    { key: "vehicleType", label: "Vehicle Type" },
    { key: "make", label: "Make" },
    { key: "model", label: "Model" },
    { key: "chassisNo", label: "Chassis No" },
    { key: "invoiceNo", label: "Invoice No" },
    { key: "purchaseDate", label: "Purchase Date" },
    { key: "purchaseValue", label: "Purchase Value" },
    { key: "cumHr", label: "Cum HR" },
    { key: "cumKm", label: "Cum KM" },
    { key: "branchName", label: "Branch" },
    { key: "vehicleId", label: "Vehicle ID" },
    { key: "rowId", label: "Detail ID" },
  ];

  const spareModalFields = [
    { key: "slNo", label: "SL No" },
    { key: "itemName", label: "Item" },
    { key: "vehicleCode", label: "Vehicle Code" },
    { key: "make", label: "Make" },
    { key: "model", label: "Model" },
    { key: "branchName", label: "Branch" },
    { key: "rowId", label: "Spare Catalogue ID" },
  ];

  const modalFields =
    selectedView === "ownVehicle" ? ownVehicleModalFields : spareModalFields;

  const displayValue = (val) => {
    if (val === undefined || val === null || String(val).trim() === "") return "-";
    return String(val);
  };

  const normalizeValue = (val) => {
    if (!val || val === "Select") return "";
    return String(val);
  };

  const getSelectedBranch = (overrideValue) => {
    if (branchType === "HO") {
      return overrideValue || selectedBranchId || branchId;
    }
    return branchId;
  };

  const normalizeRow = (row, view = selectedView) => {
    if (view === "ownVehicle") {
      return {
        ...row,
        rowId:
          row?.fld_vehicleown_detid ||
          row?.vehicleOwnDetId ||
          row?.ownDetId ||
          row?.id ||
          row?.fld_vehicleid ||
          0,
        vehicleId: row?.fld_vehicleid || row?.vehicleId || row?.VehicleID || 0,
        vehicleCode:
          row?.fld_vehicle_code || row?.vehicleCode || row?.VehicleCode || "-",
        vehicleName:
          row?.fld_vehicle_name || row?.vehicleName || row?.VehicleName || "-",
        vehicleRegNo:
          row?.fld_vehicle_regno || row?.vehicleRegNo || row?.VehicleRegNo || "-",
        vehicleType:
          row?.fld_vehicletypename || row?.vehicleType || row?.VehicleType || "-",
        make: row?.fld_vehiclemake || row?.vehicleMake || row?.make || "-",
        model: row?.fld_vehicle_model || row?.vehicleModel || row?.model || "-",
        chassisNo:
          row?.fld_Chassisno ||
          row?.fld_chasisno ||
          row?.chassisNo ||
          row?.chasisNo ||
          "-",
        invoiceNo: row?.fld_invoiceno || row?.invoiceNo || row?.invoiceNumber || "-",
        purchaseDate: row?.fld_purchaseddate || row?.purchaseDate || "-",
        purchaseValue: row?.fld_purchased_amt || row?.purchaseValue || "-",
        cumHr: row?.fld_cumHMR || row?.cumHr || row?.cumHR || "-",
        cumKm: row?.fld_cumKMR || row?.cumKm || row?.cumKM || "-",
        branchName:
          row?.fld_branchname || row?.fld_BranchName || row?.branch || "-",
      };
    }

    return {
      ...row,
      rowId: row?.fld_sparecatid || row?.spareCatId || row?.id || 0,
      slNo: row?.fld_slno || row?.slNo || "-",
      itemName: row?.fld_itemname || row?.itemName || row?.fld_description || "-",
      vehicleCode: row?.fld_vehicle_code || row?.vehicleCode || "-",
      make: row?.fld_make || row?.make || "-",
      model: row?.fld_model || row?.model || "-",
      branchName: row?.fld_BranchName || row?.fld_branchname || row?.branch || "-",
    };
  };

  const loadMeta = async (branchParam) => {
    try {
      const selected = getSelectedBranch(branchParam);

      const r = await axios.get(`${API_BASE}/dropdowns`, {
        params: {
          branchId,
          loginUserId: userId,
          branchType,
          selectedBranchId: selected,
        },
        headers: commonHeaders,
      });

      const data = r.data?.data || {};
      setBranches(Array.isArray(data?.branches) ? data.branches : []);
      setVehicleTypes(Array.isArray(data?.vehicleTypes) ? data.vehicleTypes : []);
      setStores(Array.isArray(data?.stores) ? data.stores : []);
      setSpareBranches(Array.isArray(data?.spareBranches) ? data.spareBranches : []);
      setSpareMainTypes(Array.isArray(data?.spareMainTypes) ? data.spareMainTypes : []);

      if (branchType !== "HO") {
        setSelectedBranchId(String(branchId));
        setSpareBranchId(String(branchId));
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load dropdown data!");
      setBranches([]);
      setVehicleTypes([]);
      setStores([]);
      setSpareBranches([]);
      setSpareMainTypes([]);
    }
  };

  const loadMakeModel = async (typeId) => {
    try {
      if (!typeId || typeId === "Select") {
        setMakeOptions([]);
        setModelOptions([]);
        return;
      }

      const r = await axios.get(`${API_BASE}/make-model`, {
        params: { vehicleTypeIndex: typeId },
        headers: commonHeaders,
      });

      setMakeOptions(Array.isArray(r.data?.data?.makes) ? r.data.data.makes : []);
      setModelOptions(Array.isArray(r.data?.data?.models) ? r.data.data.models : []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load Make / Model");
      setMakeOptions([]);
      setModelOptions([]);
    }
  };

  const loadList = async ({
    mode = listMode,
    nextPage = page,
    nextLimit = limit,
    view = selectedView,
  } = {}) => {
    if (!branchId) {
      toast.error("branchId missing in localStorage!");
      return;
    }

    setLoading(true);
    setSelectedRows([]);
    setHasSearched(true);

    try {
      const selected = getSelectedBranch();

      const r = await axios.get(`${API_BASE}/list`, {
        params: {
          mode,
          view,
          branchId,
          loginUserId: userId,
          branchType,
          selectedBranchId: selected,
          storeId: normalizeValue(storeId),
          vehicleTypeIndex: normalizeValue(vehicleTypeIndex),
          vehicleCode,
          vehicleName,
          vehicleRegNo,
          vehicleMake,
          vehicleModel,
          spareBranchId: normalizeValue(spareBranchId),
          spareMainTypeId: normalizeValue(spareMainTypeId),
          spareVehicleCode,
          spareItem,
          spareModel,
          spareMake,
          spareSlNo,
          page: nextPage,
          limit: nextLimit,
        },
        headers: commonHeaders,
      });

      const data = Array.isArray(r.data?.data) ? r.data.data : [];
      setRows(data.map((row) => normalizeRow(row, view)));

      const backendTotal = Number(r.data?.total);
      const backendPage = Number(r.data?.page);
      const backendLimit = Number(r.data?.limit);

      setTotal(Number.isFinite(backendTotal) ? backendTotal : data.length);
      if (Number.isFinite(backendPage) && backendPage > 0 && backendPage !== nextPage) {
        setPage(backendPage);
      }
      if (Number.isFinite(backendLimit) && backendLimit > 0 && backendLimit !== nextLimit) {
        setLimit(backendLimit);
      }

      if (data.length === 0) toast.info("No Records found");
    } catch (err) {
      console.error(err);
      toast.error("Failed to load list");
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setListMode("search");
    if (page === 1) {
      loadList({ mode: "search", nextPage: 1, nextLimit: limit });
    } else {
      setPage(1);
    }
  };

  const loadViewAll = () => {
    setListMode("all");
    if (page === 1) {
      loadList({ mode: "all", nextPage: 1, nextLimit: limit });
    } else {
      setPage(1);
    }
  };

  const onBranchChange = async (e) => {
    const val = e.target.value;
    setSelectedBranchId(val);
    setStoreId("Select");
    setVehicleTypeIndex("Select");
    await loadMeta(val);
  };

  const onVehicleTypeChange = async (e) => {
    const val = e.target.value;
    setVehicleTypeIndex(val);
    await loadMakeModel(val);
  };

  const pageIds = useMemo(
    () =>
      rows
        .map((r) => Number(r.rowId))
        .filter((id) => Number.isFinite(id) && id > 0),
    [rows]
  );

  const allSelected =
    pageIds.length > 0 && pageIds.every((id) => selectedRows.includes(id));

  const toggleRow = (id) => {
    if (!id) return;
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleAll = () => {
    if (allSelected) {
      setSelectedRows((prev) => prev.filter((id) => !pageIds.includes(id)));
    } else {
      setSelectedRows((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };

  const clearFilters = () => {
    setStoreId("Select");
    setVehicleTypeIndex("Select");
    setVehicleCode("");
    setVehicleName("");
    setVehicleRegNo("");
    setVehicleMake("");
    setVehicleModel("");
    setSpareMainTypeId("Select");
    setSpareVehicleCode("");
    setSpareItem("");
    setSpareModel("");
    setSpareMake("");
    setSpareSlNo("");

    if (branchType === "HO") setSpareBranchId("Select");
    else setSpareBranchId(String(branchId));

    setMakeOptions([]);
    setModelOptions([]);
    toast.info("Filters cleared");
  };

  const onEdit = (row) => {
    if (selectedView === "ownVehicle") {
      navigate(
        `/vehicle/OwnVehicle_DetailsEntry?vehicleId=${row.vehicleId || ""}&ownDetId=${
          row.rowId || ""
        }`
      );
      return;
    }
    navigate(`/vehicle/SparesCatalogueEntry?spareCatId=${row.rowId || ""}&mode=edit`);
  };

  const onDeleteSelected = async () => {
    if (branchActive !== "1") {
      toast.error("Branch is inactive. Delete not allowed.");
      return;
    }

    const ids = selectedRows
      .map((x) => Number(x))
      .filter((x) => Number.isFinite(x) && x > 0);

    if (!ids.length) {
      toast.warn("Please select at least one record to delete.");
      return;
    }

    const ok = window.confirm(`Are you sure you want to delete ${ids.length} record(s)?`);
    if (!ok) return;

    try {
      if (selectedView === "ownVehicle") {
        for (const id of ids) {
          // eslint-disable-next-line no-await-in-loop
          await axios.delete(`${API_BASE}/own-vehicles/${id}`, {
            headers: commonHeaders,
          });
        }
        toast.success("Deleted successfully");
      } else {
        const r = await axios.post(
          `${API_BASE}/spares/delete`,
          { ids },
          { headers: commonHeaders }
        );
        if (!r.data?.success) {
          toast.error(r.data?.message || "Delete failed");
          return;
        }
        toast.success(r.data?.message || "Deleted successfully");
      }

      await loadList({ nextPage: page, nextLimit: limit });
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Delete failed");
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await loadMeta(selectedBranchId || branchId);
      } catch (err) {
        console.error(err);
        toast.error("Failed to initialize page");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonHeaders]);

  useEffect(() => {
    loadList({
      mode: listMode,
      nextPage: page,
      nextLimit: limit,
      view: selectedView,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonHeaders, selectedView, page, limit, listMode]);

  useEffect(() => {
    if (selectedView === "ownVehicle" && vehicleTypeIndex && vehicleTypeIndex !== "Select") {
      loadMakeModel(vehicleTypeIndex);
    } else if (selectedView === "ownVehicle") {
      setMakeOptions([]);
      setModelOptions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleTypeIndex, selectedView]);

  const getVisiblePages = () => {
    const maxButtons = 5;
    if (totalPages <= maxButtons) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const half = Math.floor(maxButtons / 2);
    let start = Math.max(1, currentSafePage() - half);
    let end = start + maxButtons - 1;

    if (end > totalPages) {
      end = totalPages;
      start = end - maxButtons + 1;
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const currentSafePage = () => Math.min(Math.max(1, page), totalPages);

  const goToPage = (next) => {
    if (next < 1 || next > totalPages || next === page) return;
    setPage(next);
  };

  const handlePageSizeChange = (e) => {
    const nextSize = Number(e.target.value) || DEFAULT_PAGE_SIZE;
    setLimit(nextSize);
    setPage(1);
  };

  const addNewPath = "/vehicle/OwnVehicle_DetailsEntry";

  const pagerBtnClass = (active = false, disabled = false) =>
    `min-w-[36px] h-9 px-3 rounded-lg text-sm font-semibold border transition-all duration-200 flex items-center justify-center ${
      disabled
        ? isDark
          ? "opacity-40 cursor-not-allowed border-gray-600 text-gray-400"
          : "opacity-40 cursor-not-allowed border-gray-300 text-gray-400"
        : active
        ? `${buttonClass} text-white border-transparent shadow`
        : isDark
        ? "border-gray-600 text-gray-200 hover:bg-gray-700"
        : "border-gray-300 text-gray-700 hover:bg-white"
    }`;

  return (
    <VehicleLayoutWrapper>
      <div className={`min-h-screen p-6 ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={
            <span className="font-dmserif text-3xl">OWN VEHICLE DETAILS LISTING</span>
          }
          setSkin={setSkin}
          currentSkin={currentSkin}
        />

        <div
          className={`p-6 mt-6 rounded-2xl shadow-xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : "bg-white text-black"
          }`}
        >
          {/* HEADER */}
          <div className="flex justify-between items-center mb-6 flex-wrap gap-3">
            <div className="flex items-center gap-3 flex-wrap">
              <h2 className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
                {pageTitle}
              </h2>
              <span
                className={`px-3 py-1 rounded-full text-sm font-medium ${
                  isDark ? "bg-blue-900 text-blue-100" : "bg-blue-100 text-blue-800"
                }`}
              >
                {loading ? "..." : `${total || rows.length}`} Records
              </span>
              {selectedRows.length > 0 && (
                <span
                  className={`px-3 py-1 rounded-full text-sm font-medium ${
                    isDark ? "bg-red-900 text-red-100" : "bg-red-100 text-red-800"
                  }`}
                >
                  {selectedRows.length} Selected
                </span>
              )}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              {branchActive === "1" && (
                <button
                  onClick={() => navigate(addNewPath)}
                  className={`flex items-center gap-2 px-5 py-3 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200 ${buttonClass} ${hoverClass} text-white`}
                >
                  <FaPlus />
                  Add New
                </button>
              )}

              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform transition duration-200 ${
                  isDark
                    ? "bg-gray-700 hover:bg-gray-600 text-white border border-gray-600"
                    : "bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300"
                }`}
              >
                {showFilters ? <FaChevronUp /> : <FaChevronDown />}
                {showFilters ? "Hide Filters" : "Show Filters"}
              </button>
            </div>
          </div>

          {/* VIEW SELECTOR */}
          <div className={`p-6 rounded-lg mb-6 ${isDark ? "bg-gray-800/50" : "bg-blue-50"}`}>
            <h3 className={`text-lg font-semibold mb-4 ${isDark ? "text-white" : "text-blue-900"}`}>
              Listing Type
            </h3>
            <div className="flex flex-wrap gap-6">
              {[
                { id: "ownVehicle", label: "Own Vehicle" },
                { id: "sparesAndCatalogue", label: "Spares And Catalogue" },
                { id: "sparesScrap", label: "Spares Scrap" },
              ].map((opt) => (
                <label key={opt.id} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="radio"
                    name="viewSelection"
                    value={opt.id}
                    checked={selectedView === opt.id}
                    onChange={() => {
                      setSelectedView(opt.id);
                      setSelectedRows([]);
                      setViewRow(null);
                      setPage(1);
                      setListMode("search");
                    }}
                    className="w-4 h-4 text-blue-600 focus:ring-blue-500"
                  />
                  <span className={isDark ? "text-white" : "text-gray-900"}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* SEARCH CRITERIA */}
          {showFilters && (
            <div className={`p-6 rounded-lg mb-6 ${isDark ? "bg-gray-800/50" : "bg-blue-50"}`}>
              <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
                <h3 className={`text-lg font-semibold ${isDark ? "text-white" : "text-blue-900"}`}>
                  Search Criteria
                </h3>

                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={clearFilters}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold border ${
                      isDark
                        ? "border-gray-600 text-gray-200 hover:bg-gray-700"
                        : "border-gray-300 text-gray-700 hover:bg-white"
                    }`}
                  >
                    Clear
                  </button>

                  <button
                    onClick={loadViewAll}
                    disabled={loading}
                    className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold border ${
                      isDark
                        ? "border-gray-600 text-gray-200 hover:bg-gray-700"
                        : "border-gray-300 text-gray-700 hover:bg-white"
                    }`}
                  >
                    <FaList />
                    View All
                  </button>

                  <button
                    onClick={handleSearch}
                    disabled={loading}
                    className={`flex items-center gap-2 px-6 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${
                      loading ? "opacity-60 cursor-not-allowed" : ""
                    } ${buttonClass} ${hoverClass} text-white`}
                  >
                    <FaSearch />
                    {loading ? "Searching..." : "Search"}
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {branchType === "HO" && (
                  <div>
                    <label className={labelClass}>Branch</label>
                    <select
                      value={selectedBranchId}
                      onChange={onBranchChange}
                      className={inputClass}
                    >
                      <option value="">Select</option>
                      {branches.map((b, idx) => {
                        const id =
                          b?.id ||
                          b?.fld_Branchid ||
                          b?.BranchId ||
                          b?.branchid ||
                          b?.fld_branchid ||
                          "";
                        const name =
                          b?.name ||
                          b?.fld_BranchName ||
                          b?.BranchName ||
                          b?.branchname ||
                          id;
                        return (
                          <option key={idx} value={id}>
                            {name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                {selectedView === "ownVehicle" ? (
                  <>
                    <div>
                      <label className={labelClass}>Store</label>
                      <select
                        value={storeId}
                        onChange={(e) => setStoreId(e.target.value)}
                        className={inputClass}
                      >
                        <option value="Select">Select</option>
                        {stores.map((s, idx) => {
                          const id = s?.id || s?.fld_storeid || s?.StoreId || s?.storeid || "";
                          const name =
                            s?.name || s?.fld_storename || s?.StoreName || s?.storename || id;
                          return (
                            <option key={idx} value={id}>
                              {name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Type</label>
                      <select
                        value={vehicleTypeIndex}
                        onChange={onVehicleTypeChange}
                        className={inputClass}
                      >
                        <option value="Select">Select</option>
                        {vehicleTypes.map((v, idx) => {
                          const id = v?.id || v?.vehicleTypeIndex || v?.VehicleTypeIndex || "";
                          const name = v?.name || v?.vehicleType || v?.VehicleType || id;
                          return (
                            <option key={idx} value={id}>
                              {name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Code</label>
                      <input
                        type="text"
                        value={vehicleCode}
                        onChange={(e) => setVehicleCode(e.target.value)}
                        placeholder="Vehicle Code"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Name</label>
                      <input
                        type="text"
                        value={vehicleName}
                        onChange={(e) => setVehicleName(e.target.value)}
                        placeholder="Vehicle Name"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Reg No</label>
                      <input
                        type="text"
                        value={vehicleRegNo}
                        onChange={(e) => setVehicleRegNo(e.target.value)}
                        placeholder="Vehicle Reg No"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Make</label>
                      <input
                        type="text"
                        value={vehicleMake}
                        onChange={(e) => setVehicleMake(e.target.value)}
                        placeholder="Vehicle Make"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Model</label>
                      <input
                        type="text"
                        value={vehicleModel}
                        onChange={(e) => setVehicleModel(e.target.value)}
                        placeholder="Vehicle Model"
                        className={inputClass}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <label className={labelClass}>Spare Branch</label>
                      <select
                        value={spareBranchId}
                        onChange={(e) => setSpareBranchId(e.target.value)}
                        disabled={branchType !== "HO"}
                        className={`${inputClass} ${
                          branchType !== "HO" ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                      >
                        <option value="Select">Select</option>
                        {spareBranches.map((b, idx) => {
                          const id = b?.id || b?.fld_Branchid || b?.branchid || "";
                          const name = b?.name || b?.fld_BranchName || b?.branchname || id;
                          return (
                            <option key={idx} value={id}>
                              {name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Main Type</label>
                      <select
                        value={spareMainTypeId}
                        onChange={(e) => setSpareMainTypeId(e.target.value)}
                        className={inputClass}
                      >
                        <option value="Select">Select</option>
                        {spareMainTypes.map((v, idx) => {
                          const id = v?.id || v?.mainTypeId || "";
                          const name = v?.name || v?.mainType || id;
                          return (
                            <option key={idx} value={id}>
                              {name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div>
                      <label className={labelClass}>Vehicle Code</label>
                      <input
                        type="text"
                        value={spareVehicleCode}
                        onChange={(e) => setSpareVehicleCode(e.target.value)}
                        placeholder="Vehicle Code"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Item</label>
                      <input
                        type="text"
                        value={spareItem}
                        onChange={(e) => setSpareItem(e.target.value)}
                        placeholder="Item Name"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Make</label>
                      <input
                        type="text"
                        value={spareMake}
                        onChange={(e) => setSpareMake(e.target.value)}
                        placeholder="Make"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>Model</label>
                      <input
                        type="text"
                        value={spareModel}
                        onChange={(e) => setSpareModel(e.target.value)}
                        placeholder="Model"
                        className={inputClass}
                      />
                    </div>

                    <div>
                      <label className={labelClass}>SL No</label>
                      <input
                        type="text"
                        value={spareSlNo}
                        onChange={(e) => setSpareSlNo(e.target.value)}
                        placeholder="SL No"
                        className={inputClass}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          )}

          {/* TABLE */}
          <div className="overflow-x-auto rounded-lg border shadow-lg">
            {loading ? (
              <div className={`p-16 text-center ${isDark ? "bg-gray-800" : "bg-gray-50"}`}>
                <div className={`text-lg font-medium ${isDark ? "text-gray-300" : "text-gray-600"}`}>
                  Loading...
                </div>
              </div>
            ) : rows.length === 0 ? (
              <div className={`p-16 text-center ${isDark ? "bg-gray-800" : "bg-gray-50"}`}>
                <div className={`text-lg font-medium ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                  {hasSearched ? "No Records found" : "Please search to view records"}
                </div>
              </div>
            ) : (
              <>
                <table className={`w-full ${isDark ? "bg-gray-800" : "bg-white"}`}>
                  <thead className={`${tableHeaderClass} text-white`}>
                    <tr>
                      <th className="px-4 py-4 text-left text-sm font-semibold">S.No</th>

                      {selectedView === "ownVehicle" ? (
                        <>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Vehicle Code</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Vehicle Name</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Vehicle Reg No</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Vehicle Type</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Branch</th>
                        </>
                      ) : (
                        <>
                          <th className="px-4 py-4 text-left text-sm font-semibold">SL No</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Item</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Vehicle Code</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold">Branch</th>
                        </>
                      )}

                      <th className="px-4 py-4 text-center text-sm font-semibold">View</th>
                      <th className="px-4 py-4 text-center text-sm font-semibold">Edit</th>
                      <th className="px-4 py-4 text-center text-sm font-semibold w-16">
                        <input
                          type="checkbox"
                          checked={allSelected}
                          onChange={toggleAll}
                          className="w-4 h-4 cursor-pointer"
                          title="Select All on this page"
                        />
                      </th>
                    </tr>
                  </thead>

                  <tbody className={`${isDark ? "divide-gray-700" : "divide-gray-200"} divide-y`}>
                    {rows.map((row, idx) => {
                      const id = Number(row.rowId);
                      const checked = selectedRows.includes(id);
                      const serial = (page - 1) * limit + idx + 1;

                      return (
                        <tr
                          key={id || serial}
                          className={`${
                            idx % 2 === 0
                              ? isDark
                                ? "bg-gray-800"
                                : "bg-white"
                              : isDark
                              ? "bg-gray-750"
                              : "bg-gray-50"
                          } transition-colors ${isDark ? "hover:bg-gray-700" : "hover:bg-blue-50"}`}
                        >
                          <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                            {serial}
                          </td>

                          {selectedView === "ownVehicle" ? (
                            <>
                              <td className={`px-4 py-4 text-sm font-medium ${isDark ? "text-blue-400" : "text-blue-600"}`}>
                                {row.vehicleCode}
                              </td>
                              <td className={`px-4 py-4 text-sm font-medium ${isDark ? "text-white" : "text-gray-900"}`}>
                                {row.vehicleName}
                              </td>
                              <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                                {row.vehicleRegNo}
                              </td>
                              <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                                {row.vehicleType}
                              </td>
                              <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                                {row.branchName}
                              </td>
                            </>
                          ) : (
                            <>
                              <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                                {row.slNo}
                              </td>
                              <td className={`px-4 py-4 text-sm font-medium ${isDark ? "text-white" : "text-gray-900"}`}>
                                {row.itemName}
                              </td>
                              <td className={`px-4 py-4 text-sm font-medium ${isDark ? "text-blue-400" : "text-blue-600"}`}>
                                {row.vehicleCode}
                              </td>
                              <td className={`px-4 py-4 text-sm ${isDark ? "text-gray-300" : "text-gray-900"}`}>
                                {row.branchName}
                              </td>
                            </>
                          )}

                          <td className="px-4 py-4 text-center">
                            <button
                              type="button"
                              onClick={() => setViewRow(row)}
                              className="text-blue-500 hover:text-blue-600 text-lg transition"
                              title="View details"
                            >
                              <FaEye className="inline" />
                            </button>
                          </td>

                          <td className="px-4 py-4 text-center">
                            <button
                              type="button"
                              onClick={() => onEdit(row)}
                              disabled={branchActive !== "1"}
                              className={`text-yellow-500 hover:text-yellow-600 text-lg transition ${
                                branchActive !== "1" ? "opacity-50 cursor-not-allowed" : ""
                              }`}
                              title="Edit"
                            >
                              ✏️
                            </button>
                          </td>

                          <td className="px-4 py-4 text-center">
                            <input
                              type="checkbox"
                              checked={checked}
                              onChange={() => toggleRow(id)}
                              className="w-4 h-4 cursor-pointer"
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {branchActive === "1" && (
                  <div className="p-4">
                    <button
                      onClick={onDeleteSelected}
                      disabled={selectedRows.length === 0}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold shadow transition ${
                        selectedRows.length === 0 ? "opacity-50 cursor-not-allowed" : ""
                      } bg-red-600 hover:bg-red-700 text-white`}
                    >
                      <FaTrash />
                      Remove {selectedRows.length > 0 ? `(${selectedRows.length})` : ""}
                    </button>
                  </div>
                )}
              </>
            )}
          </div>

          {!loading && (total > 0 || rows.length > 0) && (
            <div
              className={`mt-4 flex flex-col lg:flex-row items-center justify-between gap-4 px-2 py-3 ${
                isDark ? "text-gray-300" : "text-gray-700"
              }`}
            >
              <div className="flex items-center gap-3 flex-wrap text-sm">
                <span>
                  Showing <span className="font-semibold">{pageStart}</span>–
                  <span className="font-semibold">{pageEnd}</span> of{" "}
                  <span className="font-semibold">{total || rows.length}</span> records
                </span>

                <label className="flex items-center gap-2">
                  <span>Rows per page</span>
                  <select
                    value={limit}
                    onChange={handlePageSizeChange}
                    className={`px-3 py-1.5 rounded-lg border text-sm ${
                      isDark
                        ? "bg-gray-700 border-gray-600 text-white"
                        : "bg-white border-gray-300 text-gray-900"
                    }`}
                  >
                    {PAGE_SIZE_OPTIONS.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="flex items-center gap-2 flex-wrap">
                <button
                  type="button"
                  onClick={() => goToPage(page - 1)}
                  disabled={page <= 1}
                  className={pagerBtnClass(false, page <= 1)}
                  title="Previous"
                >
                  <FaChevronLeft />
                </button>

                {getVisiblePages()[0] > 1 && (
                  <>
                    <button
                      type="button"
                      onClick={() => goToPage(1)}
                      className={pagerBtnClass(page === 1)}
                    >
                      1
                    </button>
                    {getVisiblePages()[0] > 2 && (
                      <span className="px-1 text-sm opacity-70">...</span>
                    )}
                  </>
                )}

                {getVisiblePages().map((n) => (
                  <button
                    key={n}
                    type="button"
                    onClick={() => goToPage(n)}
                    className={pagerBtnClass(n === page)}
                  >
                    {n}
                  </button>
                ))}

                {getVisiblePages().at(-1) < totalPages && (
                  <>
                    {getVisiblePages().at(-1) < totalPages - 1 && (
                      <span className="px-1 text-sm opacity-70">...</span>
                    )}
                    <button
                      type="button"
                      onClick={() => goToPage(totalPages)}
                      className={pagerBtnClass(page === totalPages)}
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  type="button"
                  onClick={() => goToPage(page + 1)}
                  disabled={page >= totalPages}
                  className={pagerBtnClass(false, page >= totalPages)}
                  title="Next"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          )}

          {viewRow && (
            <div
              className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
              onClick={() => setViewRow(null)}
            >
              <div
                className={`w-full max-w-3xl max-h-[85vh] overflow-y-auto rounded-2xl shadow-2xl border ${
                  isDark
                    ? "bg-gray-900 border-gray-700 text-white"
                    : "bg-white border-gray-200 text-gray-900"
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  className={`flex items-center justify-between px-6 py-4 border-b ${
                    isDark ? "border-gray-700" : "border-gray-200"
                  }`}
                >
                  <div>
                    <h3 className="text-xl font-bold">
                      {selectedView === "ownVehicle"
                        ? "Own Vehicle Details"
                        : "Spare Details"}
                    </h3>
                    <p className={`text-sm mt-1 ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                      {displayValue(
                        selectedView === "ownVehicle"
                          ? viewRow.vehicleCode
                          : viewRow.itemName
                      )}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setViewRow(null)}
                    className={`p-2 rounded-lg ${
                      isDark ? "hover:bg-gray-800 text-gray-300" : "hover:bg-gray-100 text-gray-600"
                    }`}
                    title="Close"
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  {modalFields.map((field) => (
                    <div
                      key={field.key}
                      className={`p-3 rounded-lg border ${
                        isDark ? "bg-gray-800/60 border-gray-700" : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <div className={`text-xs font-semibold uppercase tracking-wide mb-1 ${
                        isDark ? "text-gray-400" : "text-gray-500"
                      }`}>
                        {field.label}
                      </div>
                      <div className="text-sm font-medium break-words">
                        {displayValue(viewRow[field.key])}
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  className={`flex justify-end gap-2 px-6 py-4 border-t ${
                    isDark ? "border-gray-700" : "border-gray-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setViewRow(null)}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold border ${
                      isDark
                        ? "border-gray-600 text-gray-200 hover:bg-gray-800"
                        : "border-gray-300 text-gray-700 hover:bg-gray-50"
                    }`}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      const row = viewRow;
                      setViewRow(null);
                      onEdit(row);
                    }}
                    disabled={branchActive !== "1"}
                    className={`px-4 py-2 rounded-lg text-sm font-semibold text-white ${buttonClass} ${hoverClass} ${
                      branchActive !== "1" ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
          )}

          <ToastContainer />
        </div>
      </div>
    </VehicleLayoutWrapper>
  );
};

export default OwnDetailsListing;